import axios from 'axios';
import { LoginCredentials, ChatbotSession } from '../types';
import type { AxiosResponse, AxiosError } from 'axios';

const API_URL = 'https://chat.doorda.ai/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if it exists
api.interceptors.request.use((config: any) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Add a response interceptor to handle session expiration
api.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      localStorage.removeItem('token');
      // Redirect to login page
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export const login = async (credentials: LoginCredentials) => {
  const response = await api.post('/auth/token/', credentials);
  const { access } = response.data;
  localStorage.setItem('token', access);
  return response.data;
};

export const getMyChatbots = async () => {
  const response = await api.get('/users/my_chatbot_ids/');
  return response.data;
};

export const createChatbotSession = async (chatbotId: string, debug: boolean = true, reasoning: boolean = false): Promise<ChatbotSession> => {
  const response = await api.post('/chatbot/session/', { chatbot_id: chatbotId, debug, reasoning });
  return response.data;
};

export const getMonthlyUsage = async (chatbotId?: string) => {
  const params = chatbotId ? { params: { chatbot_id: chatbotId } } : {};
  const response = await api.get('/monthly-usage/', params);
  return response.data;
};

export const logout = () => {
  localStorage.removeItem('token');
}; 